import { useCallback } from "react";
import * as api from "./api";

// Add/remove actions for a conversation's estimation groups. The list itself
// already lives in useConversationCanvas (it's also needed by ConnectorForm),
// so this hook only owns the mutations and asks the caller to reload it.
export default function useEstimationGroups(conversationId, reload) {
    const addGroup = useCallback(
        (name) => {
            if (!name || !name.trim()) return Promise.resolve();
            return api.createEstimationGroup(name.trim(), conversationId).then(() => reload());
        },
        [conversationId, reload]
    );

    const removeGroup = useCallback(
        (id) => {
            return api.deleteEstimationGroup(id).then(() => reload());
        },
        [reload]
    );

    return { addGroup, removeGroup };
}
